module.exports = __webpack_public_path__ + "catalog/items/stairs/stairs-with-landing/Stairs-with-landing-icon.svg";